module.exports = __webpack_public_path__ + "static/canyon-riverview-80c29aa95d51f41a8efd212aab206f1e.jpg";